export const shadows = {
  base: `0px 10px 8px rgba(0, 0, 0, 0.02)`,
  md: `0px 10px 10px rgba(0, 0, 0, 0.04)`,
  lg: `0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)`,
  lgV: `0px 20px 25px -25px rgba(0, 0, 0, 0.1), 0px 10px 10px -10px rgba(0, 0, 0, 0.04)`
};
